import { PatientDetails } from "./PatientDetails";
import { SendEmail } from "../common/SendEmail";
import { DrawerDivider } from "../../../../layout/RightDrawer.style";
import { ReferralInfo } from "./ReferralInfo";
import { MediaDocumentInfo } from "../common/MediaDocumentInfo";
import { About } from "../common/About";
import { ExportSettings } from "./ExportSettings";
import { NewEpisode } from "./NewEpisode";
import { ServiceInfo } from "./ServiceInfo";
import { ReferralAttachments } from "./ReferralAttachments";
import { FEATURES, IGroupInfo } from "@home-health-notify/domain";
import { OrganizationContext } from "hhn-commons";
import { useContext } from "react";
import { PatientGroupInfoWrapper } from "./PatientGroupInfo.style";

export const PatientGroupInfo = ({ groupInfo }: { groupInfo: IGroupInfo }) => {
  const { selectedOrgUser } = useContext(OrganizationContext);
  const canViewPatientInfo =
    selectedOrgUser?.hasAccess(FEATURES.VIEW_PATIENT_INFO) ?? false;
  const canViewInternalInfo =
    selectedOrgUser?.hasAccess(FEATURES.VIEW_GROUP_INTERNAL_INFO) ?? false;
  const canStartNewEpisode =
    selectedOrgUser?.hasAccess(FEATURES.START_NEW_EPISODE) ?? false;

  const hasServiceInfo =
    !!groupInfo.info?.physician?.[0] ||
    (canViewPatientInfo &&
      (!!groupInfo.info?.careGiver?.[0] || !!groupInfo.info?.pharmacy?.[0]));

  return (
    <PatientGroupInfoWrapper>
      <PatientDetails groupInfo={groupInfo} />
      <DrawerDivider />
      {canViewInternalInfo && (
        <>
          <SendEmail />
          <DrawerDivider />
        </>
      )}
      {canViewPatientInfo && (
        <>
          <ReferralInfo groupInfo={groupInfo} />
          <ReferralAttachments groupInfo={groupInfo} />
          <DrawerDivider />
          <MediaDocumentInfo mediaList={groupInfo.mediaList || []} />
          <DrawerDivider />
        </>
      )}
      {canViewInternalInfo && groupInfo.about && groupInfo.about.length > 0 ? (
        <>
          <About groupInfo={groupInfo} /> <DrawerDivider />
        </>
      ) : null}
      {hasServiceInfo && (
        <ServiceInfo
          groupInfo={groupInfo}
          canViewPatientInfo={canViewPatientInfo}
        />
      )}
      {canViewInternalInfo && (
        <>
          <ExportSettings groupInfo={groupInfo} />
          <DrawerDivider />
        </>
      )}
      {groupInfo.isMember && canStartNewEpisode && (
        <>
          <NewEpisode chatId={groupInfo.id} />
          <DrawerDivider />
        </>
      )}
    </PatientGroupInfoWrapper>
  );
};
